/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Discover.css";
import { SHOW_ERRORS, ErrorPreview } from "./ErrorPreview";

// The "them" view a business and an individual share: verified nonprofits,
// what they have raised on Plug, and how far along this year's goal they are.
// Only fields the directory really carries — there is no cause, district or
// description on an organisation, so the card does not pretend otherwise.
class Discover extends Component {
  renderCard(o) {
    const vm = this.props.vm;
    return (
      <div className="Marketplace-OrgCard" key={o.id}>
        {/* Everything above the button opens the nonprofit’s public page.
            The button itself is left out of it: adding to a plan from the
            directory is the one thing a card already did, and swallowing
            that into a navigation would take it away. */}
        <div className="Marketplace-OrgCard-open" onClick={o.openPage}>
          <div className="Marketplace-OrgCard-head">
            <div
              className="Marketplace-OrgCard-mono"
              style={{ background: o.monoBg, color: o.monoFg, borderColor: o.monoBg }}
            >
              {o.logo ? <img src={o.logo} alt={o.name} className="Marketplace-OrgCard-monoImg" /> : o.mono}
            </div>
            <div className="Marketplace-OrgCard-headInfo">
              <div className="Marketplace-OrgCard-name">
                {o.name}
                {o.verified && <span className="Marketplace-OrgCard-check">✓</span>}
              </div>
            </div>
          </div>

          <div className="Marketplace-OrgCard-latest">
            <div className="Marketplace-OrgCard-latestLabel">{vm.m.cardLatest}</div>
            <div className="Marketplace-OrgCard-latestBody">{vm.m.cardNoUpdate}</div>
          </div>

          <div className="Marketplace-OrgCard-stats">
            <div>
              <div className="Marketplace-OrgCard-statValue">{o.raisedLabel}</div>
              <div className="Marketplace-OrgCard-statLabel">{vm.m.cardRaised}</div>
            </div>
            <div>
              <div className="Marketplace-OrgCard-statValue">{o.backers}</div>
              <div className="Marketplace-OrgCard-statLabel">{vm.m.cardSupporters}</div>
            </div>
          </div>

          <div className="Marketplace-OrgCard-goal">
            <div className="Marketplace-OrgCard-goalHead">
              <span className="Marketplace-OrgCard-goalTitle">{vm.m.cardGoalTitle}</span>
              <span className="Marketplace-OrgCard-goalStatus" style={{ color: o.goalColor }}>
                {o.goalStatus}
              </span>
            </div>
            <div className="Marketplace-bar">
              <div
                className={"Marketplace-barFill" + (o.goalAhead ? "" : " Marketplace-barFill--behind")}
                style={{ width: o.goalW }}
              />
            </div>
            <div className="Marketplace-OrgCard-goalLabel">{o.goalLabel}</div>
          </div>
        </div>

        <div
          className={"Marketplace-OrgCard-btn" + (o.inPlan ? " Marketplace-OrgCard-btn--in" : "")}
          onClick={o.toggle}
        >
          {o.btnLabel}
        </div>
      </div>
    );
  }

  render() {
    const vm = this.props.vm;
    const d = vm.discover;
    return (
      <div className="Marketplace-Discover">
        {SHOW_ERRORS && (
          <ErrorPreview m={vm.m} className="Marketplace-Discover-notice" keys={["addOrgNotReady"]} fill={{ org: "Harbour Trust" }} />
        )}
        {SHOW_ERRORS && <ErrorPreview m={vm.m} className="Marketplace-card Marketplace-status" keys={["orgsError"]} />}
        {d.addError && (
          <div className="Marketplace-Discover-notice">
            <span>{d.addError}</span>
            <span className="Marketplace-Discover-noticeClose" onClick={d.dismissAddError}>
              ×
            </span>
          </div>
        )}
        {d.orgsLoading && <div className="Marketplace-card Marketplace-status">{vm.m.orgsLoading}</div>}
        {d.orgsError && <div className="Marketplace-card Marketplace-status">{vm.m.orgsError}</div>}
        {!d.orgsLoading && !d.orgsError && (
          <div className="Marketplace-Discover-grid">{d.cards.map((o) => this.renderCard(o))}</div>
        )}
        {d.noResults && <div className="Marketplace-card Marketplace-status">{vm.m.noResults}</div>}
      </div>
    );
  }
}

Discover.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default Discover;
